import React, { useContext, useEffect, useState } from "react";

import { Table} from "react-bootstrap";
import { navigate } from "gatsby";
import {PageLinks} from "../../common/page-links";
import { getFormData, putFormData } from "../forms/api/Api"
import { Payment_Mail } from "../../common/utils/site_utlis"

// markup
const PaymentTable = (props) => {
    const[payment_info, setPaymentInfo] = useState(props.payment_info ? props.payment_info : "");

    //var payment_id = typeof window !== 'undefined' && (localStorage.getItem("payment_id") ? localStorage.getItem("payment_id") : "");

    //console.log("payment_info ==>", props.payment_info);

    useEffect(() => {
        if(props.payment_info === ""){
            var payment_id = typeof window !== 'undefined' && (localStorage.getItem("payment_id") ? localStorage.getItem("payment_id") : "");

            //console.log("payment_info ==>", props.payment_info, payment_id);

            if(payment_id){
                
                //console.log("payment_info ==>", payment_info, payment_id);
                getFormData(payment_id).then(async apiRes => {

                    //console.log("apiRes ==>", apiRes, typeof apiRes);
                    var update_form_data = {
                        extra: {...apiRes?.extra, "payment_status": props.status === "payment-success" ? "success" : "failed"}
                    }

                    // Payment all mail
                    if(props.status === "payment-success"){
                        var json_data = {
                            form_values:{...apiRes?.extra, "name": apiRes.name, "email":apiRes.email, "form_name": apiRes.form_name}
                        }
                        //Object.keys(apiRes?.extra).map(key => json_data[key] = apiRes?.extra[key])
                        //console.log("json_data", json_data);
                        var form_values = json_data.form_values;
                        //console.log("form_values ==>", form_values);
                        await Payment_Mail(form_values);
                    }
                    // Payment all mail


                    // Update Status
                    if(apiRes?.extra?.payment_status){
                        setPaymentInfo(apiRes)
                        localStorage.setItem("payment_id", "")
                    } else{
                        putFormData(update_form_data, payment_id).then(async apiRes2 => {
                            //console.log("apiRes ==> 2", apiRes);
                            if (apiRes2?.success === true) {
                                setPaymentInfo(apiRes2)
                                localStorage.setItem("payment_id", "")
                            }
                        });
                    }
                    // Update Status

                });

            } else{
                navigate(`/${PageLinks.online_payment}/`)
            }
        }
    }, [props.payment_info]);

    return (
        <>
        <Table striped bordered responsive width={"100%"} className="payment_info" cellPadding={20}>
            <tbody>
                {payment_info?.extra?.payment_status && <>
                    <tr>
                        <td className="label">Payment Status</td>
                        <td className={`label ${payment_info?.extra?.payment_status}`}>{payment_info?.extra?.payment_status}</td>
                    </tr>
                    <tr>
                        <td className="label">Order ID</td>
                        <td className="label">{payment_info?.extra?.ORDERID}</td>
                    </tr>
                    </>
                }
                <tr>
                    <td className="label">Type</td>
                    <td className="label">{payment_info?.extra?.persontype}</td>
                </tr>
                {payment_info?.extra?.department ? 
                    <tr>
                        <td className="label">Department</td>
                        <td className="label">{payment_info?.extra?.department}</td>
                    </tr>
                : ""
                }
                <tr>
                    <td className="label">Name</td>
                    <td className="label">{payment_info?.extra?.salutation} {payment_info?.extra?.first_name} {payment_info?.extra?.last_name}</td>
                </tr>
                <tr>
                    <td className="label">Email</td>
                    <td className="label">{payment_info?.email}</td>
                </tr>
                {payment_info?.extra?.property_name_number ? 
                    <tr>
                        <td className="label">Property Number</td>
                        <td className="label">{payment_info?.extra?.property_name_number}</td>
                    </tr>
                : ""
                }
                <tr>
                    <td className="label">Address</td>
                    <td className="label">{payment_info?.extra?.property_address_line_1}</td>
                </tr>
                {/* <tr>
                    <td className="label">Address 2</td>
                    <td className="label">{payment_info?.extra?.property_address_line_2}</td>
                </tr> */}
                <tr>
                    <td className="label">Town/City</td>
                    <td className="label">{payment_info?.extra?.property_town_city}</td>
                </tr>
                <tr>
                    <td className="label">Postcode</td>
                    <td className="label">{payment_info?.extra?.property_postcode}</td>
                </tr>
                <tr>
                    <td className="label">Billing Name</td>
                    <td className="label">{payment_info?.extra?.billing_salutation} {payment_info?.extra?.billing_first_name} {payment_info?.extra?.billing_last_name}</td>
                </tr>
                {payment_info?.extra?.billing_property_name_number ?
                <tr>
                    <td className="label">Billing Property Number</td>
                    <td className="label">{payment_info?.extra?.billing_property_name_number}</td>
                </tr>
                : ""
                }
                <tr>
                    <td className="label">Billing Address</td>
                    <td className="label">{payment_info?.extra?.billing_property_address_line_1}</td>
                </tr>
                {/* <tr>
                    <td className="label">Billing Address 2</td>
                    <td className="label">{payment_info?.extra?.billing_property_address_line_2}</td>
                </tr> */}
                <tr>
                    <td className="label">Billing Town/City</td>
                    <td className="label">{payment_info?.extra?.billing_property_town_city}</td>
                </tr>
                <tr>
                    <td className="label">Billing Postcode</td>
                    <td className="label">{payment_info?.extra?.billing_property_postcode}</td>
                </tr>
                <tr>
                    <td className="label">Amount</td>
                    <td className="label">{process.env.GATSBY_CURRENCY}{payment_info?.extra?.amount_full}.{payment_info?.extra?.amount_pence}</td>
                </tr>
                {payment_info?.extra?.SUB_COMMENT &&
                <tr>
                    <td className="label">Reason</td>
                    <td className="label">{payment_info?.extra?.SUB_COMMENT}</td>
                </tr>
                }

                {payment_info?.extra?.comments &&
                <tr>
                    <td className="label">Details</td>
                    <td className="label">{payment_info?.extra?.comments}</td>
                </tr>
                }
            </tbody>
        </Table>
        </>
    )
}

export default PaymentTable